<template>
  <div class="block col-md-12">
    <template v-if="hasReturnLabel">
      <div class="row">
        <h4 class="col-md-12">
          {{ $t('tracking.allowedReturn.returnOk') }} {{ returnDetails.shipment }}.
        </h4>
        <div class="col-md-12 sticker">
          <a
            class="btn green"
            target="_blank"
            rel="noopener noreferrer"
            :href="returnDetails.url"
            >{{ $t('tracking.allowedReturn.downloadSticker') }}</a
          >
        </div>
        <h4 class="col-md-12">{{ $t('tracking.allowedReturn.collectTitle') }}</h4>
        <div class="col-md-12">
          <ParcelshopPicker :postcode="returnDetails.postcode" :town="returnDetails.city" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-md-12 title">{{ $t('tracking.allowedReturn.title') }}</div>
      <div class="col-md-12">
        {{ $t('tracking.allowedReturn.wishReturn') }}
        <b>{{ $t('tracking.allowedReturn.followSteps') }}</b
        >.
      </div>
      <div class="col-md-12">
        <div class="row steps">
          <div class="col-xs-12 col-sm-4 col-md-4">
            <span class="pictos icon-printer"></span>
            <h4>{{ $t('tracking.allowedReturn.print') }}</h4>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4">
            <span class="pictos icon-file-text"></span>
            <h4>{{ $t('tracking.allowedReturn.stick') }}</h4>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4">
            <span class="pictos icon-map-marker"></span>
            <h4>{{ $t('tracking.allowedReturn.collect') }}</h4>
          </div>
        </div>
      </div>
      <div class="group col-md-12">
        <input type="email" v-model.trim="email" class="email" id="Email" />
        <span class="highlight"></span>
        <span class="bar"></span>
        <label for="Email">{{ $t('tracking.allowedReturn.email') }}</label>
      </div>
      <div class="col-md-12">
        <button
          type="button"
          class="btn green"
          :disabled="!isEmailValid"
          @click.prevent="onRequestReturn"
        >
          {{ $t('tracking.allowedReturn.validate') }}
        </button>
        <div class="engaged">{{ $t('tracking.allowedReturn.engaged') }}.</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ParcelshopPicker from '../../../../parcelshop-picker/src/components/ParcelshopPicker/ParcelshopPicker.vue';

export default {
  components: {
    ParcelshopPicker,
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState(['returnDetails']),
    hasReturnLabel() {
      return Boolean(this.returnDetails?.url);
    },
    isEmailValid() {
      if (!this.email) return false;
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(this.email);
    },
  },
  methods: {
    async onRequestReturn() {
      if (!this.isEmailValid) return;
      await this.$store.dispatch('requestReturn', { email: this.email });
      this.email = '';
    },
  },
};
</script>

<style scoped lang="scss">
@import './AllowedReturn.scss';
</style>
